import { InputAdornment, TableCell, TableRow } from "@mui/material";
import { Field } from "formik";
import { TextField } from "formik-mui";
import { styled } from "@mui/material/styles";

interface Props {
  index: number;
  substance: string;
  dwelling: string;
  fuel: string;
  appliance: string;
  weight: number;
  className?: string;
  readOnly: boolean;
}
export function RestrictionRow(props: Props) {
  const { index, substance, dwelling, fuel, appliance, className, readOnly } = props;

  return (
    <StyledTableRow className={className}>
      <TableCell component="th" scope="row">
        <span dangerouslySetInnerHTML={{ __html: substance }} />
      </TableCell>
      <TableCell component="th" scope="row">
        <span dangerouslySetInnerHTML={{ __html: dwelling }} />
      </TableCell>
      <TableCell component="th" scope="row">
        <span dangerouslySetInnerHTML={{ __html: fuel }} />
      </TableCell>
      <TableCell component="th" scope="row">
        <span dangerouslySetInnerHTML={{ __html: appliance }} />
      </TableCell>
      <TableCell component="th" scope="row" width={0} className="table-cell-percentage">
        <Field
          name={`weightList.${index}.weight`}
          component={TextField}
          size="small"
          type="number"
          disabled={readOnly}
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
            inputProps: { min: 0 },
          }}
        />
      </TableCell>
    </StyledTableRow>
  );
}

const StyledTableRow = styled(TableRow)`
  .table-cell-percentage {
    display: flex;
    flex-direction: row;
    min-width: 0px;
    gap: ${({ theme }) => theme.spacing(1)};
  }
  .MuiTextField-root {
    flex-shrink: 0;
  }

  .MuiTextField-root {
    width: var(--text-field-width);
  }
  .MuiInputBase-root {
    margin-bottom: 0;
  }
  .MuiFormHelperText-root {
    display: none;
  }
`;
